import { format, getTime, formatDistanceToNow } from "date-fns";
import moment from "moment";

// ----------------------------------------------------------------------

type InputValue = Date | string | number | null;

export function fToNowUTC(date: InputValue) {
  return date
    ? formatDistanceToNow(moment(date).utc(true).toDate(), {
        addSuffix: true,
      })
    : "";
}
